import './index.scss';

import React from 'react';
import { createRoot } from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';
import { SWRConfig } from 'swr';

import { App } from './app/App';
import { icons } from './assets/icons';
import i18n from './i18n';

(React as any).icons = icons;
const fetcher = (url: string) => fetch(url).then((res) => res.json());

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
  <I18nextProvider i18n={i18n}>
    <SWRConfig value={{ fetcher }}>
      <App />
    </SWRConfig>
  </I18nextProvider>,
);
